import { render, staticRenderFns } from "./AddGoodDialog.vue?vue&type=template&id=493961ba&scoped=true&"
import script from "./AddGoodDialog.vue?vue&type=script&lang=ts&"
export * from "./AddGoodDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493961ba",
  null
  
)

export default component.exports